<template>
  <v-container fluid class="max-width docForm">
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Purchase Orders</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-btn color="primary" class="mt-2" small to="/new-purchase-order">
            <v-icon left dark>mdi-plus</v-icon>Create Purchase Order
          </v-btn>
        </v-row>

        <v-row>
          <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
            hide-details></v-text-field>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" sm="12" md="12">
            <!-- start of table -->
            <v-data-table :headers="headers" :items="recordsData" :search="search" :mobile-breakpoint="0">
              <template v-slot:item.DocTotal="{ item }">
                <span>{{ item.DocTotal.toLocaleString() }}.00</span>
              </template>

              <template v-slot:item.CreatedAt="{ item }">
                <span>{{ item.CreatedAt | date }}</span>
              </template>

              <template v-slot:item.status>
                <span>Pending</span>
              </template>


              <template v-slot:item.action="{ item }">
                <v-btn text :to="`/purchase-orders/${item.id}`" color="accent">
                  <v-icon left>mdi-eye</v-icon> Details
                </v-btn>
              </template>

              <template v-slot:item.delete="{ item }">
                <v-btn icon color="red" @click="openDeleteModal(item)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>

            </v-data-table>
            <!-- end -->
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

        <v-dialog v-model="deleteDialog" max-width="750px">
          <v-card>
            <v-toolbar dense color="secondary" flat>
              <v-toolbar-title> Delete Lpo </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="deleteDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row class="text--primary subtitle-2">
                  <v-col cols="12">
                    Are you sure you want to delete / disable this lpo ?
                  </v-col>
                  <v-col cols="12">
                    <span style="font-size: 16px; color: red;">LPO NO: {{ selectedItem && selectedItem.DocNum }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Supplier: {{ selectedItem.supplier && selectedItem.supplier.Name }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Lpo Total: {{ selectedItem && selectedItem.DocTotal | currency }}</span>
                  </v-col>

                  <v-col cols="4">
                    <span style="font-size: 16px">Date: {{ selectedItem && selectedItem.CreatedAt | date }}</span>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="red" dark :loading="loader" @click="deleteLpo">Yes, Delete</v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>


    <snackbar ref="snackbar"></snackbar>

  </v-container>
</template>

<script>
export default {
  data: () => ({
    search: "",
    selectedItem: {},
    deleteDialog: false,
    date: new Date().toISOString().substr(0, 10),
    headers: [
      { text: "Doc No.", value: "DocNum" },
      { text: "Supplier", value: "supplier.Name" },
      { text: "Total", value: "DocTotal" },
      // { text: "Status", value: "status" },
      { text: "Date", value: "CreatedAt" },
      { text: "View Details", value: "action" },
      { text: "Delete", value: "delete" }
    ],
    recordsData: [],
  }),
  methods: {
    openDeleteModal(data) {
      this.selectedItem = data;
      this.deleteDialog = true;
    },
    deleteLpo() {
      const self = this;
      var id = parseInt(self.selectedItem.id);

      var url = `/delete-entire-lpo/${id}`;
      self.loader = true;
      this.$store
        .dispatch("remove", url)
        .then(res => {
          if (res.ResultCode != 1200) {
            self.loader = false;
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }

          if (res.ResultCode == 1200) {
            location.reload();
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      let data = {};
      data.StartDate = this.date;
      const self = this;
      const url = `/lpos`;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.recordsData = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getRecords();
  },
};
</script>